/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76102ResDataItem {
  
  /** 成员id */
  userId?: string;
  
  /** 成员名称 */
  userName?: string;
  
  /** 成员头像 */
  userHeadUrl?: string;
  
  /** 成员真实名称 */
  realName?: string;
  
};
    
  



export interface API76102Req {
  
    roomId: string;
  
};



export type API76102Res = IAPI76102ResDataItem[];


// 接口函数 76102 获取聊天室成员列表

export interface IUseGetAPI76102Return {
  /** 获取聊天室成员列表: 接口请求状态 */
  isAPI76102Loading: boolean;
  /** 获取聊天室成员列表: 接口请求返回数据 */
  dataAPI76102: API76102Res;
  /**  获取聊天室成员列表: 接口数据请求方法 */
  fetchAPI76102Data: (inputs: API76102Req, config?: YWRequestConfig) => Promise<API76102Res>;
  /** 获取聊天室成员列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76102 = ():IUseGetAPI76102Return => {
  let isMount = true;
  const [isAPI76102Loading, setIsAPI76102Loading] = useState(false);
  const [dataAPI76102, setDataAPI76102] = useState<API76102Res>({} as API76102Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/room/member/list`;

  const fetchAPI76102Data = async (inputs: API76102Req, config?: YWRequestConfig): Promise<API76102Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76102Req>) || {}) as API76102Req;
    
  
    if ( isMount ) {
      setIsAPI76102Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76102Res>(`${basePath}/yoaichat-web/chat/room/member/list/${parseParams<API76102Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76102(res || {} as API76102Res);
        setIsAPI76102Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76102Loading(false);
      }
      return false as unknown as API76102Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76102Loading,
    dataAPI76102,
    fetchAPI76102Data,
    requestUrl,
  }
}

